import {
  Box,
  Container,
  FormControl,
  Link,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import Title from "../../components/Pages/Title";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import React, { useEffect, useState } from "react";
import { Transaction } from "../../openApi/api";
import * as Api from "../../openApi";
import Pagination from "../../components/Pagination";
import { CalculatePassTime } from "../../utils";
import { useUpcxChain } from "../../hook/useUpcxChain";
import axios from "axios";
import { TransactionsService } from "../../backend";
interface NftData {
  thumbnail: string;
  tokenName: string;
  tokenId: string;
}

const MintsNFT = () => {
  const { jsonRpc, selectedShard } = useUpcxChain();
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [nftData, setNftData] = useState<NftData[]>([]);

  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);

  const handleChange = (event: SelectChangeEvent) => {
    setLimit(parseInt(event.target.value));
    setPage(0);
  };

  const getTransactions = async () => {
    const result = await TransactionsService.getTransactions(
      "nft-mint",
      limit,
      page
    );
    setTransactions(result.txs ?? []);
    setTotal(result.total ?? 0);
  };

  const getNftData = async () => {
    if (!jsonRpc) return;
    const tmpNftData: NftData[] = [];
    for (let i in transactions) {
      const data: NftData = {
        thumbnail: "",
        tokenName: JSON.parse(transactions[i].data).quantity.split(" ")[1],
        tokenId: "New",
      };

      try {
        const nftMetadata = await axios.get(
          JSON.parse(transactions[i].data).uris[0]
        );
        data.thumbnail = nftMetadata.data.thumbnail;
      } catch {}

      tmpNftData.push(data);
    }
    setNftData(tmpNftData);
  };

  useEffect(() => {
    if (!selectedShard) {
      return;
    }

    getTransactions();
    //eslint-disable-next-line
  }, [limit, page, selectedShard]);

  useEffect(() => {
    getNftData();

    //eslint-disable-next-line
  }, [transactions]);

  return (
    <>
      <Title title="NFT Mints" smallTitle="" />

      <Container className="container-xxl pt-5 pb-12">
        <Box className="card">
          <Box className="card-body">
            <Box className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <Box>
                <span className="text-dark gap-1">
                  {total.toLocaleString()} records found
                </span>
                <Box className="d-block text-muted small">
                  (Showing last 10,000 records)
                </Box>
              </Box>
              <Box className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <Box className="pagination pagination-sm mb-0">
                  <Pagination
                    limit={limit}
                    page={page}
                    setPage={setPage}
                    total={total}
                  />
                </Box>
              </Box>
            </Box>
          </Box>

          <TableContainer component={Paper} className="box-shadow-0">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    <Tooltip
                      title={"See preview of the transaction details."}
                      placement="right"
                    >
                      <HelpOutlineIcon className="text-icon text-muted" />
                    </Tooltip>
                  </TableCell>
                  <TableCell align="left" width={1}>
                    Transaction Info
                  </TableCell>
                  <TableCell align="left">
                    <Box className="d-flex align-items-center">
                      Method{" "}
                      <Tooltip
                        title={
                          "Function executed based on decoded input data. For unidentified functions, method ID is displayed instead."
                        }
                        placement="right"
                      >
                        <HelpOutlineIcon className="text-icon text-muted" />
                      </Tooltip>
                    </Box>
                  </TableCell>
                  <TableCell align="left">
                    <Box className="d-flex align-items-center">
                      <Tooltip
                        title={
                          "Function executed based on decoded input data. For unidentified functions, method ID is displayed instead."
                        }
                        placement="right"
                      >
                        <Link>Age</Link>
                      </Tooltip>
                    </Box>
                  </TableCell>
                  <TableCell align="left">From</TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left">To</TableCell>
                  <TableCell align="left">Type</TableCell>
                  <TableCell align="left">Item</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {transactions.map((data, index) => (
                  <TableRow>
                    <TableCell align="center">
                      <Box
                        className="js-tnx-preview btn btn-sm btn-white fs-70x content-center mx-auto myFnExpandBox"
                        sx={{
                          width: "1.75rem",
                          height: "1.75rem",
                        }}
                      >
                        <RemoveRedEyeOutlinedIcon className="small-icon" />
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box className="hash-tag text-truncate">
                        <Link
                          href={`/tx/${data.txId}`}
                          className="myFnExpandBox_searchVal"
                        >
                          0x{data.txId}
                        </Link>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box className="d-block badge bg-light border border-dark dark:border-white border-opacity-10 text-dark fw-normal text-truncate w-100 py-1.5">
                        <Tooltip describeChild title="Transfer" placement="top">
                          <span>{data.actionName}</span>
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell>{`${CalculatePassTime(
                      new Date(data.timestamp.substring(0, 19))
                    )} ago`}</TableCell>
                    <TableCell>
                      <Box className="d-flex d-flex align-items-center gap-1">
                        <Link
                          href={`/address/${data.sender}`}
                          className="hash-tag text-truncate border px-1 border-0"
                          data-bs-toggle="tooltip"
                          data-bs-trigger="hover"
                          data-bs-html="true"
                        >
                          {data.sender}
                        </Link>

                        <Tooltip title="Copy Address" placement="top">
                          <Link
                            className="js-clipboard link-secondary "
                            data-bs-toggle="tooltip"
                            data-bs-trigger="hover"
                            data-hs-clipboard-options='{ "type": "tooltip", "successText": "Copied!", "classChangeTarget": "#linkIcon_f_2", "defaultClass": "fa-copy", "successClass": "fa-check" }'
                            aria-label="Copy Address"
                          >
                            <ContentCopyIcon
                              className="text-icon"
                              onClick={() =>
                                navigator.clipboard.writeText(data.sender)
                              }
                            />
                          </Link>
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box
                        className="bg-success bg-opacity-10 border border-success border-opacity-25 text-success fs-70x content-center rounded-pill mx-auto"
                        sx={{
                          width: "1.5rem",
                          height: "1.5rem",
                        }}
                      >
                        <ArrowRightAltIcon className="text-icon" />
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Box className="d-flex d-flex align-items-center gap-1">
                        <Box className="d-flex align-items-center gap-1 border px-1 border-0">
                          <Tooltip title="Public NFA" placement="top">
                            <Link
                              href={`/address/${data.receiver}`}
                              className=""
                              data-bs-toggle="tooltip"
                              data-bs-trigger="hover"
                              data-bs-html="true"
                            >
                              {data.receiver}
                            </Link>
                          </Tooltip>
                        </Box>

                        <Tooltip title="Copy Address" placement="top">
                          <Link className="js-clipboard link-secondary ">
                            <ContentCopyIcon
                              className="text-icon"
                              onClick={() =>
                                navigator.clipboard.writeText(data.receiver)
                              }
                            />
                          </Link>
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box className="badge border text-dark fw-normal rounded-pill px-2 py-1.5">
                        UIA-721
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Link
                        className="d-flex align-items-center gap-2 link-dark"
                        target="_parent"
                      >
                        <Box className="content-center">
                          <img
                            className="rounded"
                            src={
                              nftData[index]
                                ? nftData[index].thumbnail
                                : "https://storage.googleapis.com/nftimagebucket/tokens/0xb586d1dc01178ce79046e00ede62a3218722dfdd/TVRjd01qVXhOVGc1TWc9PV8xOTg3.png"
                            }
                            width="40"
                            height="40"
                            alt="Item logo"
                          />
                        </Box>
                        <Box className="flex-grow-1">
                          <Box
                            className="hash-tag text-truncate"
                            style={{ maxWidth: "11rem;" }}
                          >
                            <Box
                              data-bs-toggle="tooltip"
                              data-bs-trigger="hover"
                              data-bs-html="true"
                              data-bs-boundary="viewport"
                              data-bs-placement="top"
                            >
                              {nftData[index]
                                ? nftData[index].tokenName
                                : "unknown"}{" "}
                              #{nftData[index] ? nftData[index].tokenId : ""}
                            </Box>
                          </Box>
                          <Box className="d-flex align-items-center gap-1 small">
                            <Box className="hash-tag text-truncate text-muted">
                              <Box
                                data-bs-toggle="tooltip"
                                data-bs-trigger="hover"
                                data-bs-html="true"
                                data-bs-boundary="viewport"
                              >
                                {nftData[index]
                                  ? nftData[index].tokenName
                                  : "UNKNOWN"}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box className="card-body">
            <Box className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <Box
                id="ContentPlaceHolder1_pageRecords"
                className="d-flex align-items-center gap-2 text-nowrap text-muted"
              >
                Show:
                <FormControl sx={{ m: 1, minWidth: 70 }}>
                  <Select
                    value={limit.toString()}
                    onChange={handleChange}
                    displayEmpty
                    size="small"
                    sx={{
                      fontSize: "12px",
                    }}
                  >
                    <MenuItem
                      value={10}
                      sx={{
                        fontSize: "12px;",
                      }}
                    >
                      10
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={25}
                    >
                      25
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={50}
                    >
                      50
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={100}
                    >
                      100
                    </MenuItem>
                  </Select>
                </FormControl>
                Records
              </Box>
              <Box className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <Box className="pagination pagination-sm mb-0">
                  <Pagination
                    limit={limit}
                    page={page}
                    setPage={setPage}
                    total={total}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default MintsNFT;
